
import PropTypes from "prop-types";
import { useState, useRef } from "react";
import useOutsideClickCapture from "../Hooks/outsideClickCapture";
import { logoutUser } from '@pages/probate/globalstore';
import { useDispatch } from 'react-redux';
import {logoutDocAssemble} from '@api';
import environment from 'environment';

function UserLogin(props) {

    const wrapperRef = useRef(null);
    const { username, logout } = props;
    const [show, setShow] = useState(false);
    const dispatch = useDispatch();
    const onOutSideClick = () => {
        setShow(!show);
    }

    function close() {
        setShow(false);
    }
    const onLogoutClick = async () => {

        var reponse = await dispatch(logoutUser());

        if (reponse.payload) {
            window.localStorage.removeItem("userData");
        }
        logoutDocAssemble();
        setTimeout(() => {
            window.location.href = reponse.payload.logoutUrl;
        }, 1000);

    }



    useOutsideClickCapture(wrapperRef, close);

    return (<div className="navbar-collapse" >
        <ul className="navbar-nav ml-md-auto">
            <li className="nav-item ml-2 ml-md-0 my-2 my-md-0">
                <div ref={wrapperRef} className={`dropdown user-dropdown d-inline-block ${show ? 'show' : ''}`} onBlur={close}><strong>{username}</strong>
                    <a onClick={onOutSideClick} target="_blank" rel="noreferrer" className="user-status user-default dropdown-toggle" title="User" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i className="fas fa-user"></i></a>
                    <div className={`dropdown-menu  ${show ? 'show' : ''}`} >
                        <a className="dropdown-item " target="_blank" rel="noreferrer" href={`${environment.updateProfileURL}`}>Update Profile</a> 
                        <a className="dropdown-item " target="_blank" rel="noreferrer" onClick={onLogoutClick}>Log out</a>
                    </div>
                </div>
            </li>
        </ul>
    </div>)
}

UserLogin.propTypes = {
    username: PropTypes.string,
    logout: PropTypes.func.isRequired
}

export default UserLogin;